import React from 'react';

export const PlaySvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M19.5 9.402c2 1.155 2 4.041 0 5.196l-9 5.196c-2 1.155-4.5-.288-4.5-2.598V6.804c0-2.31 2.5-3.753 4.5-2.598zm-1 3.464a1 1 0 0 0 0-1.732l-9-5.196a1 1 0 0 0-1.5.866v10.392a1 1 0 0 0 1.5.866z"
            clipRule="evenodd"
        />
    </svg>
);
